import { useEffect } from 'react';

export function TrainingPage() {
  useEffect(() => {
    document.title = 'Shopkeeper Training | SaralPrint';
    document.querySelector<HTMLMetaElement>('meta[name="description"]')?.setAttribute(
      'content',
      'A quick SaralPrint training video for print-shop owners and staff.',
    );
  }, []);

  return (
    <main className="training-page">
      <header className="training-topbar">
        <a className="brand" href="/" aria-label="SaralPrint home">
          <img src="/saral-print-icon.png?v=icon-1" alt="" />
          <span className="brand-wordmark" aria-hidden="true">
            <span className="brand-wordmark-saral">SARAL</span>
            <span className="brand-wordmark-print">PRINT</span>
          </span>
        </a>
        <a className="training-home-link" href="/">Shopkeeper portal</a>
      </header>

      <section className="training-content" aria-labelledby="training-title">
        <div className="training-intro">
          <span>SHOPKEEPER TRAINING</span>
          <h1 id="training-title">Learn SaralPrint in a few minutes.</h1>
          <p>Watch this video before setting up your print counter. You can pause, replay, or watch it full-screen.</p>
        </div>

        <div className="training-video-frame">
          <video controls playsInline preload="metadata" poster="/saral-print-icon.png">
            <source src="/shopkeeper-training-v1.mp4" type="video/mp4" />
            Your browser does not support video playback. Please update your browser and try again.
          </video>
        </div>

        <aside className="training-note">
          <strong>Need help after watching?</strong>
          <span>Open the Shopkeeper portal and contact SaralPrint support from your account.</span>
        </aside>
      </section>
    </main>
  );
}
